import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeletedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 61,
	viewBox: "0 0 61 61",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 53,
			height: 53,
			rx: 26.5,
			fill: "url(#paint0_linear_23220_211)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 53,
			height: 53,
			rx: 26.5,
			stroke: "url(#paint1_linear_23220_211)",
			strokeWidth: 7
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 48.5L51.5 13",
			stroke: "#919191",
			strokeWidth: 7
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_23220_211",
			x1: 54.5,
			y1: .499997,
			x2: 14.2143,
			y2: 58.3571,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .155982,
				stopColor: "#424242"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#515151"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_23220_211",
			x1: 12.9286,
			y1: 9.07143,
			x2: 51.5,
			y2: 53.2143,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A5A5A5" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#737373"
			})]
		})] })
	]
});
export default SvgDeletedIcon;
